export default {
    title_list: 'Контент сайта',
    title_page: 'Страница сайта',
    title_create_page: 'Создать страницу сайта',
    title_edit_page: 'Изменить страницу сайта',

    filter: {
        labels: {
            title: 'Название',
        }
    },

    table: {
        labels: {
            id: 'ID',
            link: 'Ссылка',
            title: 'Название',
        }
    },

    buttons: {

    },

    form: {
        slug: 'Ключ',
        link: 'Ссылка',
        title: 'Заголовок в браузере',
        description: 'Описание страницы',
        meta_title: 'Заголовок для поисковых систем',
        meta_description: 'Описание для поисковых систем',
        meta_keywords: 'Ключевые слова',
        meta_social_title: 'Заголовок для социальных сетей',
        meta_social_description: 'Описание для социальных сетей',
        meta_social_image: 'Изображение для социальных сетей',
    },
}
